(ns common.breadcrumbs.view
  (:require ["@mui/material/Breadcrumbs$default" :as Breadcrumbs]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Skeleton$default" :as Skeleton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["src/svg/editor/editing/copy.svg$default" :as Copy]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :refer [adset-query]]
            [common.resource.query.advertiser :refer [advertiser-query]]
            [common.resource.query.agency :refer [agency-query]]
            [common.resource.query.campaign :refer [campaign-query]]
            [common.resource.query.user :refer [user-query]]
            [common.uix.hooks :refer [use-copy-with-toaster]]
            [manage.adset.util :as adset-util]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui breadcrumb-item [{:keys [entity label href link swap-fn hidden?]}]
  (let [url-context (use-subscribe [:url-context])
        href (or href (and link (r.easy/href link url-context)))]
    ($ Stack
       {:direction "row"
        :alignItems "center"
        :spacing 0.5
        :data-testid (str (name entity) "-breadcrumb")}
       ($ Link
          {:href href
           :color "text.secondary"
           :underline (if href "hover" "none")}
          (or label ($ Skeleton {:width "12rem"})))

       (when (and swap-fn (not hidden?))
         ($ Tooltip
            {:placement "bottom"
             :title (str "Switch to another " (name entity))}
            ($ IconButton
               {:onClick swap-fn
                :data-testid (str (name entity) "-switch")
                :sx #js {:padding 0}}
               ($ Icon "swap_horiz")))))))

(defui breadcrumbs []
  (let [url-context (use-subscribe [:url-context])
        os-enabled? (use-subscribe [:common.os/enabled])
        {user :data} (use-query (user-query))
        {agency :data} (use-query (agency-query url-context))
        {advertiser :data} (use-query (advertiser-query url-context))
        {campaign :data} (use-query (campaign-query url-context))
        {adset :data} (use-query (adset-query url-context))

        has-multiple-roles? (> (count (:roles user)) 1)
        has-multiple-advertisers? (> (count (:advertiserIds (:role user))) 1)

        crumb-mapping {:agency {:label (:name agency)
                                :swap-fn (when has-multiple-roles?
                                           #(rf/dispatch [:ocp/open {:id :switch-agency-ocp/view}]))}
                       :advertiser {:label (:name advertiser)
                                    :swap-fn #(rf/dispatch [:ocp/open {:id :switch-advertiser-ocp/view}])
                                    :hidden? (not has-multiple-advertisers?)}
                       :campaign {:label (:name campaign)}
                       :adset {:label (:name adset)
                               :href (adset-util/landing-url-from-workflow (:workflow adset) url-context)}}

        route-data (use-subscribe [:router/route-data])
        crumb-items (cond-> (:breadcrumbs route-data)
                      os-enabled? (->> (remove #(#{:agency :advertiser} (:entity %)))
                                       (cons {:entity :campaigns
                                              :label "Campaigns"
                                              :link :advertiser/page}))
                      true (->> (map #(merge % ((:entity %) crumb-mapping)))))

        [context-menu set-context-menu] (uix/use-state nil)

        handle-context-menu (fn [e]
                              (.preventDefault e)
                              (set-context-menu
                               (when (nil? context-menu)
                                 {:mouseX (+ (.-clientX e) 2)
                                  :mouseY (- (.-clientY e) 6)})))

        handle-close (fn []
                       (set-context-menu nil))

        copy-to-clipboard (use-copy-with-toaster {:success-message "Copied page url"})]
    ($ :div {:onContextMenu handle-context-menu}
       ($ Breadcrumbs
          (for [{:keys [entity] :as crumb-item} crumb-items]
            ($ breadcrumb-item (assoc crumb-item :key entity))))
       ($ Menu
          {:open (map? context-menu)
           :onClose handle-close
           :anchorReference "anchorPosition"
           :anchorPosition (when-let [{:keys [mouseY mouseX]} context-menu]
                             #js {:top mouseY
                                  :left mouseX})}
          ($ MenuItem
             {:onClick (fn []
                         (handle-close)
                         (copy-to-clipboard (.. js/location -href)))}
             ($ SvgIcon ($ Copy))
             "Copy page url")))))
